import React from 'react'
import moment from 'moment';
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem';
import MovementOrderByTransactionFilter from "../../component/Filter/MovementOrderByTransactionFilter";
import { dayMonthYearAtTimeWithSeconds } from '../../utils/dates';

class MovementOrderByProductType {

  showNewButton = false;

  defaultSort = 'date';

  title = "Ordens de movimentação por transação"

  customBreadcrumbs = [
    <BreadcrumbItem title="Lista de movimentação de itens" to="/list/movement-by-product-type" key={1}/>,
    <BreadcrumbItem title="Ordens de movimentação por transação" key={2}/>
  ]

  customFilters = {
    ready: false,
    startDate: moment().subtract(6, 'days').toDate(),
    endDate: new Date(),
  };

  columns = [
    {
      Header: 'Transação',
      accessor: 'transactionId',
      Cell: (row) => row.original && row.original.transactionId && <a href={`#/transactions/${row.original.transactionId}`}>{row.original.transactionId}</a> || ''
    },
    {
      Header: 'Código da ordem de movimentação',
      accessor: 'movementOrder.code',
      Cell: (row) => row.original.movementOrder && row.original.movementOrder.code
    },
    {
      Header: 'Referência',
      accessor: 'productType.reference',
      Cell: (row) => row.original.productType && row.original.productType.reference
    },
    {
      Header: 'Nome',
      accessor: 'productType.friendlyName',
      Cell: (row) => row.original.productType && row.original.productType.friendlyName
    },
    {
      Header: 'Quantidade',
      accessor: 'total',
      Cell: (row) => row.original.productType && row.original.total
    },
    {
      Header: 'Data',
      accessor: 'movementDate',
      Cell: (row) => row.original.movementDate && dayMonthYearAtTimeWithSeconds(row.original.movementDate)
    }
  ]

  endpoint = () => {
    const {ready, bizLocationOut, bizLocationIn, productType, date} = this.customFilters;
    if (ready === false) {
      return false;
    }

    const params = new URLSearchParams({});
    bizLocationOut && params.append('_bizLocationIdOut', bizLocationOut.id);
    bizLocationIn && params.append('_bizLocationIdIn', bizLocationIn.id);
    productType && params.append('_productTypeId', productType.id);
    date && params.append('_localDate', moment(date).format('YYYY-MM-DD'))

    return `ton/v1/movements/transactions?${params.toString()}`;
  };

  customFilterComponent = (props, state, onChange) => {
    return (
        <MovementOrderByTransactionFilter
            {...props}
            customFilters={this.customFilters}
            onChange={(newFilters) => {
              this.customFilters = {...this.customFilters, ...newFilters};
              console.log('this.customFilters', this.customFilters, newFilters);
              onChange(newFilters);
            }}
            parentState={state}/>)
  }

}

export default MovementOrderByProductType;



// WEBPACK FOOTER //
// ./src/customGrid/entities/MovementOrderByProductType.js